import React from 'react';

const QuizStepIndicator = ({
  currentStep,
  numSteps,
  onClicks,
  stepText = 'Step',
}) => {
  return (
    <div className="flex flex-1 items-center justify-between gap-3 min-w-0">
      <div className="font-mono text-[11px] tracking-wider text-darkrock/50 uppercase whitespace-nowrap">
        {stepText} {currentStep} / {numSteps}
      </div>
      <div className="flex gap-1">
        {[...Array(numSteps)].map((_, index) => {
          const step = index + 1;
          const isFilled = step <= currentStep;
          const onClick = step < currentStep ? onClicks[index] : null;
          return (
            <div
              key={step}
              onClick={onClick}
              className={`w-5 h-1.5 rounded-full transition-colors ${
                isFilled ? 'bg-pastelgreen' : 'bg-black/10'
              } ${onClick ? 'cursor-pointer' : 'cursor-default'}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default QuizStepIndicator;
